module.exports = __webpack_public_path__ + "img/case1-3.94bcde26.png";